import { defineStore } from "pinia";

const MAX_HISTORY_CONTACT_SEARCH = 10

export const useStoreSettings = defineStore('settings', {
    state: () => ({
        /** key: routename (see: component Graph) */
        table: {} as Record<string, any>,
        contactHideDetail: false,
        contactPedagogicalCollapseCom: false,
        contactPedagogicalCollapseAssigns: false,
        contactPedagogicalHideShared: false,
        contactSearchLast: [] as number[]
    }),
    actions: {
        addContactSearch(id: number) {
            const contactSearched = [id, ...this.contactSearchLast].filter(uniq)
            if (contactSearched.length > MAX_HISTORY_CONTACT_SEARCH)
                contactSearched.splice(MAX_HISTORY_CONTACT_SEARCH, contactSearched.length - MAX_HISTORY_CONTACT_SEARCH)
            this.contactSearchLast = contactSearched
        }
    }
})


function uniq(value, index, self) {
    return self.indexOf(value) === index
}